import o from "./contact-channels84.js";
import F from "./contact-channels88.js";
import x from "./contact-channels89.js";
import v from "./contact-channels90.js";
import g from "./contact-channels91.js";
import w from "./contact-channels85.js";
var b = {
  allow_display_name: !1,
  allow_underscores: !1,
  require_display_name: !1,
  allow_utf8_local_part: !0,
  require_tld: !0,
  blacklisted_chars: "",
  ignore_max_length: !1,
  host_blacklist: [],
  host_whitelist: []
}, p = /^([^\x00-\x1F\x7F-\x9F\cX]+)</i, D = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i, $ = /^[a-z\d]+$/, q = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i, E = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A1-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i, U = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i, k = 254;
function C(a) {
  var e = a.replace(/^"(.+)"$/, "$1");
  if (!e.trim())
    return !1;
  var i = /[\.";<>]/.test(e);
  if (i) {
    if (e === a)
      return !1;
    var l = e.split('"').length === e.split('\\"').length;
    if (!l)
      return !1;
  }
  return !0;
}
function y(a, e) {
  if (o(a), e = w(e, b), e.require_display_name || e.allow_display_name) {
    var i = a.match(p);
    if (i) {
      var l = i[1];
      if (a = a.replace(l, "").replace(/(^<|>$)/g, ""), l.endsWith(" ") && (l = l.slice(0, -1)), !C(l))
        return !1;
    } else if (e.require_display_name)
      return !1;
  }
  if (!e.ignore_max_length && a.length > k)
    return !1;
  var _ = a.split("@"), t = _.pop(), f = t.toLowerCase();
  if (e.host_blacklist.length > 0 && F(f, e.host_blacklist) || e.host_whitelist.length > 0 && !F(f, e.host_whitelist))
    return !1;
  var r = _.join("@");
  if (e.domain_specific_validation && (f === "gmail.com" || f === "googlemail.com")) {
    r = r.toLowerCase();
    var n = r.split("+")[0];
    if (!x(n.replace(/\./g, ""), {
      min: 6,
      max: 30
    }))
      return !1;
    for (var m = n.split("."), s = 0; s < m.length; s++)
      if (!$.test(m[s]))
        return !1;
  }
  if (e.ignore_max_length === !1 && (!x(r, {
    max: 64
  }) || !x(t, {
    max: 254
  })))
    return !1;
  if (!v(t, {
    require_tld: e.require_tld,
    ignore_max_length: e.ignore_max_length,
    allow_underscores: e.allow_underscores
  })) {
    if (!e.allow_ip_domain)
      return !1;
    if (!g(t)) {
      if (!t.startsWith("[") || !t.endsWith("]"))
        return !1;
      var c = t.slice(1, -1);
      if (c.length === 0 || !g(c))
        return !1;
    }
  }
  if (e.blacklisted_chars && r.search(new RegExp("[".concat(e.blacklisted_chars, "]+"), "g")) !== -1)
    return !1;
  if (r[0] === '"' && r[r.length - 1] === '"')
    return r = r.slice(1, r.length - 1), e.allow_utf8_local_part ? U.test(r) : q.test(r);
  for (var d = e.allow_utf8_local_part ? E : D, h = r.split("."), u = 0; u < h.length; u++)
    if (!d.test(h[u]))
      return !1;
  return !0;
}
export {
  y as default
};
//# sourceMappingURL=contact-channels65.js.map
